import { graphql } from 'gatsby'
import React from 'react'

import ArticleGridSection from '../components/article-grid-section/ArticleGridSection'
import BlogPost from '../components/blog-post/BlogPost'
import RequestAccess from '../components/request-access/RequestAccess'
import SEOControl from '../components/seoControl/seoControl'
import {
  BAMBOO_LOGO_SRC,
  BAMBOO_ORGANIZATION_NAME,
  DEFAULT_IMAGE_FOLDER,
  SITE_URL,
} from '../constants/seo'

const TITLE = 'Bamboo - Post'
const DESCRIPTION = 'Learn more about Bamboo investment App'
const KEYWORDS =
  'bamboo, blockchain, gold, silver, precious metals, bitcoin, ethereum, digital assets, litecoin, crypto, buy, invest, invest today, micro investment, microinvestment, micro-investment, solvency protocol, proof of solvency, spare change, budget'

const postTemplate = ({ data, pageContext }) => {
  const { markdownRemark } = data
  const { frontmatter, html, excerpt, fields } = markdownRemark

  const author = pageContext.author.node

  const path = frontmatter.path ? `/blog/${frontmatter.path}/` : fields.slug

  const socialSharingImage =
    frontmatter?.socialimage?.base || frontmatter?.postimage?.base

  const schemaTitle = JSON.stringify(frontmatter.title || TITLE)
  const schemaDescription = JSON.stringify(
    frontmatter.description || excerpt || DESCRIPTION
  )

  const schemaMarkup = `{
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "${SITE_URL}${path}"
      },
      "headline": ${schemaTitle},
      "description": ${schemaDescription},
      "image": "${
        socialSharingImage && DEFAULT_IMAGE_FOLDER + socialSharingImage
      }",
      "author": {
        "@type": "Person",
        "name": "${author.frontmatter.name}"
      },
      "publisher": {
        "@type": "Organization",
        "name": "${BAMBOO_ORGANIZATION_NAME}",
        "logo": {
          "@type": "ImageObject",
          "url": "${BAMBOO_LOGO_SRC}"
        }
      },
      "datePublished": "${frontmatter.date}"
    }`

  return (
    <>
      <SEOControl
        title={frontmatter.title || TITLE}
        description={frontmatter.description || excerpt || DESCRIPTION}
        image={
          socialSharingImage && `${DEFAULT_IMAGE_FOLDER}${socialSharingImage}`
        }
        keywords={KEYWORDS}
        type="article"
        schemaMarkup={schemaMarkup}
      />
      <BlogPost
        title={frontmatter.title}
        postImage={frontmatter?.postimage?.childImageSharp?.gatsbyImageData}
        thumbnail={
          author?.frontmatter?.authorimage?.childImageSharp?.gatsbyImageData
        }
        authorName={author.frontmatter.name}
        content={html}
        pubDate={frontmatter.date}
      />
      <ArticleGridSection source={pageContext.moreArticles} />
      <RequestAccess />
    </>
  )
}

export default postTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      excerpt(pruneLength: 155)
      html
      fields {
        slug
      }
      frontmatter {
        title
        description
        path
        date(formatString: "MMMM DD, YYYY")
        postimage {
          base
          childImageSharp {
            gatsbyImageData(width: 540)
          }
        }
        author
        socialimage {
          base
          childImageSharp {
            gatsbyImageData(quality: 80)
          }
        }
      }
    }
    sitePage {
      path
    }
  }
`
